import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { Accordion } from "../../../../../../../react-core/Html/Accordion";
import { PercentageTextBoxEditor } from "../../../../../../../react-core/Html/PercentageTextBoxEditor";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { DrawdownModel } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownModel";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { Typography } from "../../../../../../Shared/Typography/Typography";
import { isCappedOrFlexIOrUFPLS, isRegualr } from "./Helper/DrawdownDetailHelper";
import {TaxYearHelper} from "../../Helpers/TaxYearHelper";

import { drawdownDetailsMessage, LTADetailHeading, LTADetailTooltiopMessage } from "./Resource/Contents";

interface ILTABreakdownDetailsProps extends IProcessComponentProps {
    lessThan75: boolean;
    data: DrawdownModel;
    process: ProcessType;
    doCalculation: VoidFunction;
    hasEnhancedPensionProtection: boolean;
}

interface ILTABreakdownDetailsState {}

export class LTABreakdownDetails extends ProcessComponent<ILTABreakdownDetailsProps, ILTABreakdownDetailsState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private renderLTATextBox(): JSX.Element {
        const { data, onChange } = this.props;
        return (
            <PercentageTextBoxEditor
                cssWrapper="control-size-100"
                isNotForm={true}
                value={data?.SlaUsedOffPlatform}
                atLeast={{
                    errorMessage: drawdownDetailsMessage.LTAInputErrorMessage,
                    value: 0,
                }}
                lessThan={{ errorMessage: drawdownDetailsMessage.LTAMaxErrorMsg, value: 999.99 }}
                alwaysValidateOnUpdate={true}
                onChange={(v) => {
                    this.onDataChange(onChange, { SlaUsedOffPlatform: v }, data);
                }}
                onBlur={(v) => this.props.doCalculation()}
                maxNumberOfDecimalPlaces={{ errorMessage: "only allow two decimal places", value: 2 }}
                required={"Please enter"}
            />
        );
    }

    private renderLTARadios(): JSX.Element {
        const { data, onChange } = this.props;
        return (
            <RadiosEditor
                cssWrapper="radio-group rg-150 mb-23"
                selected={data?.AllowanceDetails?.LumpSumDeathBenefitAllowanceUsedSeriousIllHealthBefore75?? false}
                options={[true, false]}
                getText={(v) => {
                    return v ? "Yes" : "No";
                }}
                onChange={(v) => {
                    this.onDataChange(onChange, { AllowanceDetails: {
                        ...data.AllowanceDetails,
                        LumpSumDeathBenefitAllowanceUsedSeriousIllHealthBefore75: v }}, data);}}
            />
        );
    }

    private renderLTADetails(): JSX.Element {
        const { lessThan75, data, hasEnhancedPensionProtection } = this.props;
        const LifetimeAllowance = data?.LifetimeAllowance;
        const LTADetails = [];
        
        LTADetails.push({
            title: LTADetailHeading.otherLTA,
            data: this.renderLTATextBox(),
            tooltip: LTADetailTooltiopMessage.otherLTA,
        });
        if (lessThan75) {
            LTADetails.push({
                title: LTADetailHeading.isPartOfUsedSIHBefore75,
                data: this.renderLTARadios(),
                tooltip: LTADetailTooltiopMessage.otherLTA,
            });
        }

        return (
            <Accordion label="Lifetime Allowance (LTA) details" cssWrapper="accordion-with-arrow" isOpen={true}>
                <Typography type="common" wrapCss="dt-bold wider pt-12" config={LTADetails} />
            </Accordion>
        );
    }

    public render(): JSX.Element {
        return <>{this.renderLTADetails()}</>;
    }
}
